export const translations = {
  ru: {
    nav: {
      about: 'О себе',
      services: 'Услуги',
      contact: 'Контакты'
    },
    hero: {
      name: 'Лилия Губарева',
      title: 'Адвокат',
      slogan: 'Стратегия вместо хаоса. Мышление вместо эмоций.',
      cta: 'Связаться со мной'
    },
    about: {
      title: 'О себе',
      text: 'Лилия Губарева — адвокат с более чем 10-летним опытом практики. Специализируюсь на сложных семейных, наследственных, имущественных и уголовных делах. Моя цель — не просто сопровождать процесс, а добиваться результата для клиента, используя глубокие знания законодательства, стратегическое мышление и безупречную репутацию. Каждое дело для меня — это вызов, в котором важны точность, логика и профессионализм.',
      experience: '10+ лет опыта',
      cases: 'Сотни успешных дел',
      approach: 'Индивидуальный подход'
    },
    services: {
      title: 'Услуги',
      family: {
        title: 'Семейные дела',
        description: 'Бракоразводные процессы, алименты, споры о детях, раздел имущества супругов'
      },
      inheritance: {
        title: 'Наследственные вопросы',
        description: 'Оформление наследства, споры между наследниками, завещания'
      },
      property: {
        title: 'Имущественные споры',
        description: 'Споры о праве собственности, защита прав на недвижимость'
      },
      business: {
        title: 'Хозяйственные дела',
        description: 'Представительство в хозяйственных судах, договорные споры'
      },
      criminal: {
        title: 'Уголовные дела',
        description: 'Защита прав обвиняемых и потерпевших, представительство в суде'
      },
      consulting: {
        title: 'Консультации и договоры',
        description: 'Правовые консультации, составление договоров, правовая экспертиза'
      }
    },
    contact: {
      title: 'Контакты',
      phone: 'Телефон',
      email: 'Email',
      address: 'Адрес',
      addressValue: 'улица Змиевская, 63Б, Безлюдовка, Харьковская область, 62489',
      callButton: 'Позвонить',
      emailButton: 'Написать'
    },
    footer: {
      copyright: '© 2025 Лилия Губарева. Все права защищены.',
      privacy: 'Политика конфиденциальности',
      disclaimer: 'Отказ от ответственности'
    },
    privacyPage: {
      title: 'Политика конфиденциальности',
      content: 'Ваша конфиденциальность важна для меня. Я не собираю и не передаю личные данные третьим лицам без вашего согласия. Все данные, предоставленные через форму обратной связи или электронную почту, используются исключительно для ответа на ваш запрос.'
    },
    disclaimerPage: {
      title: 'Отказ от ответственности',
      content: 'Информация, размещенная на этом сайте, носит общеознакомительный характер и не является юридической консультацией. Для получения индивидуальной консультации обращайтесь непосредственно к адвокату.'
    }
  },
  uk: {
    nav: {
      about: 'Про себе',
      services: 'Послуги',
      contact: 'Контакти'
    },
    hero: {
      name: 'Лілія Губарєва',
      title: 'Адвокат',
      slogan: 'Стратегія замість хаосу. Мислення замість емоцій.',
      cta: 'Зв\'язатися зі мною'
    },
    about: {
      title: 'Про себе',
      text: 'Лілія Губарєва — адвокат з понад 10-річним досвідом практики. Спеціалізуюся на складних сімейних, спадкових, майнових та кримінальних справах. Моя мета — не просто супроводжувати процес, а досягати результату для клієнта, використовуючи глибокі знання законодавства, стратегічне мислення та бездоганну репутацію. Кожна справа для мене — це виклик, у якому важливі точність, логіка та професіоналізм.',
      experience: '10+ років досвіду',
      cases: 'Сотні успішних справ',
      approach: 'Індивідуальний підхід'
    },
    services: {
      title: 'Послуги',
      family: {
        title: 'Сімейні справи',
        description: 'Розлучення, аліменти, спори про дітей, поділ майна подружжя'
      },
      inheritance: {
        title: 'Спадкові питання',
        description: 'Оформлення спадщини, суперечки між спадкоємцями, заповіти'
      },
      property: {
        title: 'Майнові суперечки',
        description: 'Суперечки щодо права власності, захист прав на нерухомість'
      },
      business: {
        title: 'Господарські справи',
        description: 'Представництво в господарських судах, договірні суперечки'
      },
      criminal: {
        title: 'Кримінальні справи',
        description: 'Захист прав обвинувачених і потерпілих, представництво в суді'
      },
      consulting: {
        title: 'Консультації та договори',
        description: 'Правові консультації, складання договорів, правова експертиза'
      }
    },
    contact: {
      title: 'Контакти',
      phone: 'Телефон',
      email: 'Email',
      address: 'Адреса',
      addressValue: 'вулиця Зміївська, 63Б, Безлюдівка, Харківська область, 62489',
      callButton: 'Подзвонити',
      emailButton: 'Написати'
    },
    footer: {
      copyright: '© 2025 Лілія Губарєва. Усі права захищені.',
      privacy: 'Політика конфіденційності',
      disclaimer: 'Відмова від відповідальності'
    },
    privacyPage: {
      title: 'Політика конфіденційності',
      content: 'Ваша конфіденційність важлива для мене. Я не збираю і не передаю особисті дані третім особам без вашої згоди. Усі дані, надані через форму зворотного зв\'язку або електронну пошту, використовуються виключно для відповіді на ваш запит.'
    },
    disclaimerPage: {
      title: 'Відмова від відповідальності',
      content: 'Інформація, розміщена на цьому сайті, носить загальноознайомчий характер і не є юридичною консультацією. Для отримання індивідуальної консультації звертайтеся безпосередньо до адвоката.'
    }
  },
  en: {
    nav: {
      about: 'About',
      services: 'Services',
      contact: 'Contact'
    },
    hero: {
      name: 'Liliia Hubarieva',
      title: 'Attorney at Law',
      slogan: 'Strategy over chaos. Reason over emotion.',
      cta: 'Contact me'
    },
    about: {
      title: 'About',
      text: 'Liliia Hubarieva is an attorney with over 10 years of practice. I specialize in complex family, inheritance, property, and criminal cases. My goal is not just to support the process, but to achieve results for the client, using deep knowledge of the law, strategic thinking, and an impeccable reputation. Every case is a challenge for me, where accuracy, logic, and professionalism matter.',
      experience: '10+ years of experience',
      cases: 'Hundreds of successful cases',
      approach: 'Individual approach'
    },
    services: {
      title: 'Services',
      family: {
        title: 'Family Law',
        description: 'Divorce proceedings, alimony, child custody disputes, marital property division'
      },
      inheritance: {
        title: 'Inheritance Matters',
        description: 'Estate registration, disputes between heirs, wills'
      },
      property: {
        title: 'Property Disputes',
        description: 'Ownership disputes, real estate rights protection'
      },
      business: {
        title: 'Commercial Cases',
        description: 'Representation in commercial courts, contractual disputes'
      },
      criminal: {
        title: 'Criminal Cases',
        description: 'Defense of the accused and victims, court representation'
      },
      consulting: {
        title: 'Consultations & Contracts',
        description: 'Legal consultations, contract drafting, legal expertise'
      }
    },
    contact: {
      title: 'Contact',
      phone: 'Phone',
      email: 'Email',
      address: 'Address',
      addressValue: '63B Zmiivska Street, Bezliudivka, Kharkiv Region, 62489',
      callButton: 'Call',
      emailButton: 'Email'
    },
    footer: {
      copyright: '© 2025 Liliia Hubarieva. All rights reserved.',
      privacy: 'Privacy Policy',
      disclaimer: 'Disclaimer'
    },
    privacyPage: {
      title: 'Privacy Policy',
      content: 'Your privacy is important to me. I do not collect or share personal data with third parties without your consent. All data provided through the contact form or email is used exclusively to respond to your inquiry.'
    },
    disclaimerPage: {
      title: 'Disclaimer',
      content: 'The information posted on this website is for general informational purposes and does not constitute legal advice. For individual consultation, please contact the attorney directly.'
    }
  }
};